import NotFoundException from "../../../Routes/SellScreen/Exceptions/Data/NotFoundException";
import { type BaseSystemRepository } from "../../_Bases/BaseSystemRepository";
import { type LocalDatabaseSystem } from "../../_Bases/BaseSystemRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBSystemRepository extends BaseIndexedDBRepository<
    LocalDatabaseSystem<unknown>
> implements BaseSystemRepository {
    public readonly source: InternalIndexedDBDatabase["system"];
    protected readonly dataTypeName = "System";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.system;
    }

    public get<TValue>(key: string): Promise<TValue> {
        return this.source
            .get(key)
            .then(value => {
                if(!value) {
                    throw new NotFoundException(`${this.dataTypeName} Not Found (${key})`);
                }

                return value.value;
            });
    }
}
